module.exports = __webpack_public_path__ + "VIPC2.png?40941ec69f2f2a337602b739eb6426dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/cycling/VIPC2.png
// module id = 65
// module chunks = 0